import React, { useState, useRef } from "react";

import Header from "../web/Header";
import Footer from "../web/Footer";
import { Link, useNavigate } from "react-router-dom";  // ✅ useNavigate जोड़ा
import Breadcrumbs from "../ui/Breadcrumbs";

const Layout = ({ children }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate(); 

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    console.log("Logout clicked");
  };

  const handleCardClick = (link) => {
    navigate(link);
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Breadcrumbs/>

      <div className="pt-2 pb-6 px-4 md:px-6 lg:px-10">
      
      </div>

      {children && (
        <div className="px-4 md:px-6 lg:px-10 pb-6">
          <div className="max-w-7xl mx-auto">{children}</div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Layout;
